import api_config from '../config/api'

export default {
	getOurTeam(lang) {
		return api_config.get(`api/our_team/${lang}`)
	},
}
